// Bump the relevant version whenever a calculator's persisted form shape changes
// (field renamed, added, removed, or semantics change). On hydration, any
// persisted form whose stored version does not match the value here is cleared.
export const MODEL_FORM_VERSIONS = {
    clatModelForm: 1,
    crutModelForm: 1,
    gratModelForm: 1,
    iraModelForm: 1,
    ngtModelForm: 1,
    oilGasModelForm: 1,
    ppliModelForm: 1,
    qsbsModelForm: 1,
    solarModelForm: 1,
    estateBurnModelForm: 1,
};

// Routes on which the frontend re-checks the products version from the backend.
export const PRODUCTS_VERSION_POLL_ROUTES = [/-calculator(\/|$)/];
